import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Snackbar, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Card, Dropdown, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Dots from "@assets/images/Menu - Mini.svg";
// import "./style.css";
import WheelComponent from "../../../../components/WheelComponent";
import { TextView } from "../../../../components";
import { ASSETS } from "../../../../utils/config";

export default function MainWheel({ mainName, data, onShareClick }) {
  const nav = useNavigate();

  const [chartState, setChartState] = useState([]);
  useEffect(() => {
    const wheelData = data && data?.wheel_section[0]?.activity_wheel;

    const wheelUpdatedData = wheelData?.map((obj, index) => ({
      label: "blank",
      value: "1",
      isBlank: false,
      // position: 0,
      ...obj,
    }));

    const wheelUpdatedDataSorted = wheelUpdatedData?.sort(
      (a, b) => a.position - b.position
    );

    setChartState(wheelUpdatedDataSorted);
  }, [data]);

  const onCardPress = (e) => {
    if (data?.id) {
      nav(`/wheelView/${data?.id}`);
    } else {
      console.error("Data ID not available");
    }
  };

  return (
    <>
      {data ? (
        <Stack
          onClick={onCardPress}
          style={{
            marginBottom: "3px",
            cursor: "pointer",
            border: "1px solid #F6F7F9",
            borderRadius: "10px",
            margin: "10px",
            width: "91vw",
            position: "relative",
            backgroundImage: `url(${ASSETS.gradientBg})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Stack>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "2vh",
              }}
            >
              <TextView
                style={{
                  fontSize: "20px",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontFamily: "DM Sans",
                  color: "#565556",
                  fontWeight: "700",
                }}
              >
                {mainName}
              </TextView>
              <img
                src={ASSETS.share}
                alt="menu"
                width={30}
                height={30}
                style={{ zIndex: 1000 }}
                onClick={(event) => {
                  event.stopPropagation();
                  onShareClick();
                }}
              />
            </div>

            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <div
                style={{
                  paddingTop: "12px",
                  position: "relative",
                }}
              >
                <WheelComponent
                  userData={{
                    id: Math.random() * 10,
                    url: data?.wheel_image,
                  }}
                  maxSelectedArcs={0}
                  arcThickness={-10}
                  chartData={chartState}
                  containerDivStyle={{
                    height: "70vh",
                    width: "70vw",
                    marginTop: "-21vh",
                    marginBottom: "-16vh",
                  }}
                ></WheelComponent>
              </div>
            </div>
          </Stack>
        </Stack>
      ) : null}
    </>
  );
}
